import VersionModel from './version.ts';

export default class PslfFormVersionModel extends VersionModel {}
